"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propagateLogout = exports.attachSingleSignOut = void 0;
var _constants = require("../../constants");
const logoutChannel = new BroadcastChannel(_constants.LOGOUT_CHANNEL_NAME);
const propagateLogout = () => logoutChannel.postMessage(_constants.LOGOUT_CHANNEL_MESSAGE);
exports.propagateLogout = propagateLogout;
const attachSingleSignOut = (userManager, config, logger) => {
  logoutChannel.onmessage = async e => {
    if (e.data === _constants.LOGOUT_CHANNEL_MESSAGE) {
      try {
        await Promise.all([userManager.removeUser(), userManager.revokeTokens(), userManager.clearStaleState()]);
        await config.afterSignOutPropagation();
      } catch (e) {
        logger.error("Error during single signout process:", e);
      }
    }
  };
};
exports.attachSingleSignOut = attachSingleSignOut;
//# sourceMappingURL=index.js.map